export class InterceptBindingBehavior {
 
	readonly interceptMethods = ['updateTarget', 'updateSource', 'callSource'];

	bind(binding, scope, interceptor) {
		let i = this.interceptMethods.length;
		while (i--) {
			let method = this.interceptMethods[i];
			if (!binding[method]) {
				continue;
			}
			binding[`intercepted-${method}`] = binding[method];
			let update = binding[method].bind(binding);
			binding[method] = interceptor.bind(binding, method, ()=>update());
		}
	}

	unbind(binding, scope) {
		let i = this.interceptMethods.length;
		while (i--) {
			let method = this.interceptMethods[i];
			if (!binding[method]) {
				continue;
			}
			binding[method] = binding[`intercepted-${method}`];
			binding[`intercepted-${method}`] = null;
		}
	}
}